export default __webpack_public_path__ + "static/media/dg-img.f322c384.webp";